import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  addStaffLoading: false,
  staff: [],
  attendanceStaff: [],
  allStaff: [],
  facilityClients: [],
  loadingFacilityClients: false,
  staffById: {},
  activeStaffCount: 0,
};

export const staffState = createSlice({
  name: "staff",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload,
      };
    },
    setAddStaffLoading(state, action) {
      return {
        ...state,
        addStaffLoading: action?.payload,
      };
    },
    setStaff(state, action) {
      return {
        ...state,
        loading: false,
        addStaffLoading: false,
        staff: { staffs: action?.payload },
      };
    },
    setSingleStaff(state, action) {
      return {
        ...state,
        loading: false,
        singleStaff: action?.payload,
      };
    },
    setAttendanceStaff(state, action) {
      return {
        ...state,
        loading: false,
        addAttendanceStaffLoading: false,
        attendanceStaff: { attendanceStaff: action?.payload },
      };
    },
    setFacilityClients(state, action) {
      return {
        ...state,
        loadingFacilityClients: false,
        facilityClients: action?.payload,
      };
    },
    setloadingFacilityClients(state, action) {
      return {
        ...state,
        loadingFacilityClients: action?.payload,
      };
    },
    setStaffCounts(state, action) {
      return {
        ...state,
        loading: false,
        addStaffLoading: false,
        staffCount: action?.payload,
      };
    },
    setFacilityClientsCount(state, action) {
      return {
        ...state,
        loading: false,
        facilityClientsLoading: false,
        facilityClientsCount: action?.payload,
      };
    },
    setAllStaff(state, action) {
      return {
        ...state,
        loading: false,
        addStaffLoading: false,
        allStaff: action?.payload,
      };
    },
    setActiveStaffCount(state, action) {
      return {
        ...state,
        activeStaffCount: action?.payload,
      };
    },
    // Reset State
    reset() {
      return initialState;
    },
  },
});

export const {
  setLoading,
  setAddStaffLoading,
  setStaff,
  setSingleStaff,
  setAttendanceStaff,
  setFacilityClients,
  setFacilityClientsCount,
  setAllStaff,
  setStaffCounts,
  setloadingFacilityClients,
  setActiveStaffCount
} = staffState.actions;
export default staffState.reducer;
